import Finances from './Finances.view';

export default Finances;
